import { AxiosError } from 'axios';
import { baseService } from 'services';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';
import { IGithubAuth } from 'interface/githubInterface';
import { commonError, createGithubUserEP } from './constants';

class GithubAuthMockService {
  commonResponse = async <T = null>(
    data: T | null = null,
  ): Promise<ISuccessResponse<T> | IErrorResponse<AxiosError>> => {
    try {
      return await new Promise<ISuccessResponse>(resolve => {
        setTimeout(() => {
          resolve({
            data: data ?? null,
            status: 200,
            message: 'success',
          });
        }, 1000);
      });
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
  createGithubUser = async () => {
    return this.commonResponse();
  };
}

class GithubAuthService {
  createGithubUser = async (
    payload: IGithubAuth,
  ): Promise<ISuccessResponse<IGithubAuth> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(createGithubUserEP, payload);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
}

const githubAuthService: GithubAuthService | GithubAuthMockService =
  process.env.REACT_APP_MOCK_API === 'true'
    ? new GithubAuthMockService()
    : new GithubAuthService();

export default githubAuthService;
